import * as React from "react";
import {Component} from "react";
import styles from "../../../styles/flyouts/superadmin/materials/Properties.scss";
import * as _ from "lodash";
import {withRouter} from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../../core/utils";
import {setNotification} from "../../../redux/actions/general/notification";
import EditMaterialForm from "../../../forms/superadmin/materials/EditMaterialForm";
import {listMaterials, updateMaterial} from "../../../redux/actions/table/superadmin/materials";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateMaterial(formData.id, _.omit(formData, ['id'])).then(() => {
                listMaterials();

                this.props.readAction(formData.id);

                setNotification(__('properties.notifications.properties-have-been-saved'));
            })
        );
    }

    render() {
        const {data} = this.props;

        return (
            <div className={styles.scroller}>
                <EditMaterialForm
                    onSubmit={this._handleSubmit}
                    initialValues={{
                        ..._.pick(data, ['id', 'name', 'raw_materials', 'file']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
